import styled from "styled-components";
import { colors, device } from "../../../theme";

const Heading = styled.div.withConfig({
  displayName: "Heading",
})`
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: ${({ color }: { color?: string }) => color || colors.white};

  @media ${device.mobileL} {
    font-size: 35px;
  }

  @media ${device.tablet} {
    font-size: 70px;
  }
`;

export default Heading;
